<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <!-- no filters or sorting -->

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="getWarrantyTypeList" :optional-filters="filters" :paginationEnabled="true"
          :show-filter-tab="false" :show-sorting-tab="false" :itemsPerPage="50" ref="ListPane"
          :dialog-trigger="dialogtrigger" :dialogItem="editItem" :dialog-method-config="dialogMethodConfig" :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @click="setEditItem(item)"></ListItem>
          </template>

          <template v-slot:dialog-content="{ item, trigger }">
            <v-container class="px-4" v-if="item" :key="trigger">
              <v-row no-gutters>
                <v-col cols="12">
                  <QTextField v-model="item.Description" :label="$t('servicesystem.common_objects.lead.lead_type_name')"
                    externaledit :rules="[requiredRule]">
                  </QTextField>
                </v-col>
              </v-row>
            </v-container>
          </template>

        </ListPane>
      </template>

    </Layout>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/views/admin/warrantytype/WarrantyTypeListItem.vue";

export default {
  name: "AdminWarrantyTypeList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "WTL-",
      editItem: null,
      dialogtrigger: 1,
      dialogMethodConfig: {
        Create: {
          IsClientApiMethod: true,
          Name: 'createWarrantyType',
        },
        Change: {
          IsClientApiMethod: true,
          Name: 'changeWarrantyType',
        },
      },
    };
  },

  mounted() { },

  methods: {
    handleadded: (item) => this.$refs.ListPane.handleadded(item),
    handlechanged: (item) => this.$refs.ListPane.handlechanged(item),

    setEditItem(item) {
      this.dialogtrigger++;
      this.editItem = item;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>